/**
 * API della schermata Oggi: promemoria del giorno, conferma, notifiche sul telefono.
 * `/reminders` e SOLO_LEI: `title_it` porta il nome del farmaco come l'ha detto lei, mai la dose.
 */
import type { ReminderChannel, ReminderKind, ReminderStatus } from '@mamma/contracts'

import { api } from './client'

export type ReminderItem = {
  id: string
  kind: ReminderKind
  at: string
  status: ReminderStatus
  channels: ReminderChannel[]
  ack_status: 'confermato' | 'rimandato' | null
  title_it: string | null
  note: string | null
}

export type PushConfig = { enabled: boolean; public_key: string | null; subscriptions: number }

export type PushSubscriptionBody = { endpoint: string; keys: { p256dh: string; auth: string } }

export const oggiApi = {
  reminders: (from: Date, to: Date) =>
    api.get<{ reminders: ReminderItem[] }>(
      `/reminders?from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`,
    ),
  ack: (id: string, status: 'confermato' | 'rimandato') =>
    api.post<{ reminder: ReminderItem }>(`/reminders/${id}/ack`, { status }),
  pushConfig: () => api.get<PushConfig>('/push/config'),
  subscribe: (body: PushSubscriptionBody) => api.post<{ subscribed: boolean }>('/push/subscriptions', body),
  unsubscribe: (endpoint: string) => api.del<{ removed: boolean }>('/push/subscriptions', { endpoint }),
  pushTest: () => api.post<{ sent: number }>('/push/test'),
}
